import { createStore, applyMiddleware, compose } from 'redux'
import reducers from './reducers'
import { NODE_ENVIRONMENT } from '@zing/shared/constants'

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
  }
}

const composeEnhancers =
  (NODE_ENVIRONMENT === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) ?? compose

export const store = createStore(reducers, composeEnhancers(applyMiddleware()))
export { useSelector, Provider } from 'react-redux'
export * from './reducers'
export * from '@zing/shared/theme'
export * from '@zing/shared/domain/feature/hub/company/challenge/FormWrapper/store'
export * from '@zing/shared/domain/feature/hub/company/challenge/FormWrapper/store/validations'
export * from '@zing/shared/domain/feature/hub/company/challenge/FormWrapper/files/store'
export * from '@zing/shared/domain/feature/hub/company/events/FormWrapper/store'
export * from '@zing/shared/domain/feature/hub/company/events/FormWrapper/store/validations'
export * from '@zing/shared/domain/feature/hub/company/events/FormWrapper/file/store'
export * from '@zing/shared/domain/feature/hub/startup/challenge/applicationForm/store'
export * from '@zing/shared/components/menu/side/store'
export * from '@zing/shared/components/menu/state/content/store'
export * from '@zing/shared/components/menu/state/control/store'
export * from '@zing/shared/domain/feature/hub/evaluator/challenge/store'
export * from '@zing/shared/domain/feature/hotsite/store'
export * from '@zing/shared/domain/feature/hotsite/Forms/Register/store'
export * from '@zing/shared/domain/feature/hub/company/challenge/evaluators/assign/store'
